module.exports = __webpack_public_path__ + "static/7-a21100de7afec63186a6384be11b1a96.png";